import _createClass from "@babel/runtime/helpers/esm/createClass";
import DefaultAdapter from './adapters/default';
import { slugify } from '@s-ui/js/lib/string/slugify';

var Rosetta = /*#__PURE__*/function () {
  function Rosetta(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$adapter = _ref.adapter,
        adapter = _ref$adapter === void 0 ? new DefaultAdapter() : _ref$adapter;

    this._culture = null;
    this._currency = null;
    this._languages = null;
    this.translator = adapter;
  }

  var _proto = Rosetta.prototype;

  // Given a culture, it refreshes the translator with the current language.
  _proto._updateTranslator = function _updateTranslator(_ref2) {
    var culture = _ref2.culture;

    var _culture$split = culture.split('-'),
        locale = _culture$split[0];

    var translations = this._languages[culture];
    this.translator.locale = locale;
    this.translator.translations = translations;
  }
  /**
   * Add new languages or modify current ones.
   *
   * @param {String} culture The culture we want to update, takes current if left empty
   * @param {String} key Key in where to store the translation, if empty, will overwrite the language
   * @param {Object} translations Translations to be added
   */
  ;

  _proto.addTranslations = function addTranslations(_ref3) {
    var culture = _ref3.culture,
        key = _ref3.key,
        translations = _ref3.translations;
    var newCulture = culture || this._culture;

    if (key) {
      this._languages[newCulture][key] = translations; // won't work for nested keys
    } else {
      this._languages[newCulture] = translations;
    }

    this._updateTranslator({
      culture: newCulture
    });
  } // Translate.
  ;

  _proto.t = function t(key, values) {
    return this.translator.translate(key, values);
  } // Format number.
  ;

  _proto.n = function n(number, options) {
    if (options === void 0) {
      options = {};
    }

    if (typeof number !== 'number') {
      throw new Error('i18n.n should receive a number.');
    }

    return typeof Intl !== 'undefined' ? new Intl.NumberFormat(this._culture, options).format(number) : number;
  } // Format currency number.
  ;

  _proto.c = function c(number, minimumFractionDigits) {
    if (minimumFractionDigits === void 0) {
      minimumFractionDigits = 0;
    }

    return this.n(number, {
      style: 'currency',
      currency: this._currency,
      minimumFractionDigits: minimumFractionDigits
    });
  }
  /**
   * Format minor types.
   *
   * @param {String} type The kind of value to be formatted:
   *                        - phone
   * @param {} value The value to be formatted
   * @param {Object} options Specific options for the specified type
   */
  ;

  _proto.f = function f(type, value, options) {
    if (options === void 0) {
      options = {};
    }

    if (typeof type !== 'string') throw new Error('i18n.f should receive a string as a first argument');
    if (typeof value === 'undefined') throw new Error('i18n.f should receive any value as a second argument');

    switch (type) {
      case 'percentage':
        {
          var _options = options,
              _options$minimumFract = _options.minimumFractionDigits,
              minimumFractionDigits = _options$minimumFract === void 0 ? 0 : _options$minimumFract,
              _options$maximumFract = _options.maximumFractionDigits,
              maximumFractionDigits = _options$maximumFract === void 0 ? 2 : _options$maximumFract;
          return this.n(value / 100, {
            style: 'percent',
            minimumFractionDigits: minimumFractionDigits,
            maximumFractionDigits: maximumFractionDigits
          });
        }

      case 'phone':
        {
          var _options2 = options,
              _options2$separator = _options2.separator,
              separator = _options2$separator === void 0 ? ' ' : _options2$separator;
          return value.replace(/ /g, '') // reset all spaces
          .match(/.{1,3}/g) // group by chunks of 3
          .join(separator);
        }
    }

    throw new Error("Invalid type '" + type + "' passed to i18n.f");
  };

  _proto.formatPercentage = function formatPercentage(value, options) {
    return this.f('percentage', value, options);
  };

  _proto.formatPhone = function formatPhone(phoneNumber, options) {
    return this.f('phone', phoneNumber, options);
  };

  _proto.url = function url(urlPattern, allowQueryParams) {
    var _this = this;

    return urlPattern.split('/').map(function (token) {
      return slugify(_this.t(token), allowQueryParams);
    }).join('/');
  };

  _createClass(Rosetta, [{
    key: "adapter",
    get: function get() {
      return this.translator;
    },
    set: function set(adapter) {
      this.translator = adapter;
    }
  }, {
    key: "culture",
    get: function get() {
      return this._culture;
    },
    set: function set(culture) {
      this._culture = culture;

      this._updateTranslator({
        culture: culture
      });
    }
  }, {
    key: "currency",
    get: function get() {
      return this._currency;
    },
    set: function set(currency) {
      this._currency = currency;
    }
  }, {
    key: "locale",
    get: function get() {
      return this.translator.locale;
    }
  }, {
    key: "currencySymbol",
    get: function get() {
      var value = this.n(0, {
        style: 'currency',
        currency: this.currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });

      if (typeof value !== 'string') {
        return;
      }

      return value.replace(/\d/g, '').trim();
    }
  }, {
    key: "languages",
    get: function get() {
      return this._languages;
    },
    set: function set(languages) {
      this._languages = languages;
    }
  }]);

  return Rosetta;
}();

export { Rosetta as default };